import React from 'react';

const Svg = (): React.ReactElement => {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 5.44237V11C11 11.5523 10.5523 12 10 12H1C0.447715 12 0 11.5523 0 11V5.44237C0 5.16062 0.118853 4.89195 0.327328 4.70243L4.82733 0.611521C5.20875 0.264774 5.79125 0.264774 6.17267 0.611521L10.6727 4.70243C10.8811 4.89195 11 5.16062 11 5.44237Z"
        fill="white"
      />
    </svg>
  );
};

export default Svg;
